var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03877 1.23313L4.91394 4.35796L1.78911 1.23313C1.47502 0.919035 0.967633 0.919035 0.653539 1.23313C0.339445 1.54722 0.339445 2.05461 0.653539 2.3687L4.35018 6.06534C4.66428 6.37944 5.17166 6.37944 5.48575 6.06534L9.1824 2.3687C9.49649 2.05461 9.49649 1.54722 9.1824 1.23313C8.8683 0.927089 8.35287 0.919035 8.03877 1.23313Z",
    fill: "#4A5866"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownGrey);
export default __webpack_public_path__ + "static/media/arrow-down-grey.196fff1374ea19393c4cffba1b7c387b.svg";
export { ForwardRef as ReactComponent };